import { DefaultSeo as Seo } from 'next-seo'
import createSeoConfig from '~/lib/next-seo-defaults'
import { useTranslation } from '~/components/TranslationContext'
import { useCurrentUrl } from '~/components/CurrentUrlContext'

const DefaultSeo = () => {
  const { t } = useTranslation()
  const currentUrl = useCurrentUrl()
  const description = t('common:site.description')

  return <Seo {...createSeoConfig(description, currentUrl)} />
}

export default DefaultSeo
